import { useEffect, useRef } from "react";
import { isMobile } from "react-device-detect";

export default function DevToolsGuard({
  children,
}: {
  children: React.ReactNode;
}) {
  const destroyedRef = useRef(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    if (isMobile) return;
    /* ---------- 1. Chặn phím tắt ---------- */
    const keyHandler = (e: KeyboardEvent) => {
      const forbidden =
        e.key === "F12" ||
        ((e.ctrlKey || e.metaKey) &&
          e.shiftKey &&
          e.altKey &&
          ["I", "J", "C"].includes(e.key));

      if (forbidden) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    /* ---------- 2. Disable chuột phải ---------- */
    const blockContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
    };

    /* ---------- 3. Detect DevTools → self destruct ---------- */
    const threshold = 160;

    const destroyPage = () => {
      if (destroyedRef.current) return;
      destroyedRef.current = true;

      try {
        // Xoá toàn bộ DOM
        window.open("", "_self");
        window.close(); // vẫn fail
        window.location.replace("about:blank");
      } catch {
        // ignore
      }
    };

    const detectDevTools = () => {
      const w = window.outerWidth - window.innerWidth;
      const h = window.outerHeight - window.innerHeight;

      if (w > threshold || h > threshold) {
        destroyPage();
      }
    };

    window.addEventListener("keydown", keyHandler, true);
    window.addEventListener("contextmenu", blockContextMenu, true);

    const interval = setInterval(detectDevTools, 300);

    return () => {
      window.removeEventListener("keydown", keyHandler, true);
      window.removeEventListener("contextmenu", blockContextMenu, true);
      clearInterval(interval);
    };
  }, []);

  return <>{children}</>;
}
